module.exports = __webpack_public_path__ + "img/P8_popup_thumb_1_cn.e2f168ae.png";